import { StyledBadge, StyledIcon, StyledLabel } from "./badge.style";
import { IMDSBadgeProps, MDSBadgeVariant } from "./badge.types";

export const MDSBadge = ({
  icon,
  label,
  variant = MDSBadgeVariant.Default,
  className,
  id,
}: IMDSBadgeProps) => {
  return (
    <StyledBadge className={className} id={id} data-mds-name="badge" $variant={variant}>
      {icon && <StyledIcon kind={icon} />}
      <StyledLabel>{label}</StyledLabel>
    </StyledBadge>
  );
};
